import React from "react";
import {
  ErrorWrapper,
  ErrorContent,
  ContentImage,
  ContentText,
  ButtonGroup
} from "./practice-error.styles";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import { Icon } from "design-system/components/icon/icon";
import ErrorImage from "public/assets-v2/illustrations/error.svg";

interface PracticeErrorScreenProps {
  onRetry: () => void;
  onContactSupport?: () => void;
  isEmbedded?: boolean;
}

export const PracticeErrorScreen: React.FC<PracticeErrorScreenProps> = ({
  onRetry,
  onContactSupport,
  isEmbedded = false
}) => {
  return (
    <ErrorWrapper $isEmbedded={isEmbedded}>
      <ErrorContent>
        <ContentImage src={ErrorImage} alt={"error"} />
        <ContentText>Ups, error. Coba lagi untuk memuat Latihan</ContentText>
      </ErrorContent>
      <ButtonGroup>
        <Button
          appearance="general"
          variant="primary"
          size={ButtonSize.lg}
          isFullWidth
          onClick={onRetry}
        >
          <Icon name="action-reload" />
          Coba lagi
        </Button>
        {onContactSupport && (
          <Button
            appearance="general"
            variant="secondary"
            size={ButtonSize.lg}
            isFullWidth
            onClick={onContactSupport}
          >
            Chat Kakak Siaga di WA
          </Button>
        )}
      </ButtonGroup>
    </ErrorWrapper>
  );
};
